import { BizLocationType } from "src/pages/organization/org-types";
import { Order, Sort } from "../public-types";

export interface OrgListParams {
  page?: number;
  size?: number;
  sort?: Sort;
  id?: string; // 계약자 ID
  containsCorRegNo?: string; // 법인 등록번호
  containsBizRegNo?: string; // 사업자 등록번호
  containsName?: string; // 계약자(법인명/상호)
  search001?: string; // 전체검색
  search002?: string;
  keyword?: string;
  classification?: string;
  bizType?: string;
  bizLocationType?: string; // 국가
}

enum TaxType {
  GENERAL = "GENERAL",
  SIMPLIFIED_A = "SIMPLIFIED_A",
  SIMPLIFIED_B = "SIMPLIFIED_B",
  FREE = "FREE",
  ETC = "ETC",
}

enum BizType {
  SP = "SP",
  CORP = "CORP",
}

enum MediaType {
  PROOF = "PROOF",
  LOGO = "LOGO",
}

interface RequestInfo {
  id?: string;
  containsName?: string;
  containsBizRegNo?: string;
  containsCorRegNo?: string;
  containsPhoneNumber?: string;
  containsEmail?: string;
  page?: number;
  size?: number;
  sort?: {
    orders?: Array<Order>;
  };
  keyword?: string;
  search001?: string;
}

interface SendBody {
  organization: SaveOrgDto;
  mediaList: SaveMediaDto[];
}

interface SaveOrgDto {
  id?: number;
  bizType: BizType;
  name: string;
  bizRegNo: string;
  corRegNo: string;
  ceoName: string;
  bizCondition: string;
  bizItem: string;
  taxType: TaxType;
  address: string;
  email?: string | null;
  phoneNumber?: string | null;
  classifications?: string[];
  partnerId?: string;
}

interface SaveMediaDto {
  id?: number;
  fileStorageType: string;
  key: string;
  url?: string;
  filename: string;
  contentType: string;
  fileSize: number;
  type: MediaType;
  orderNums?: number;
  blobUrl?: string; // 엑셀 파일 핸들링시 클라이언트에서 사용
  serviceTag?: string;
  cmdType?: "C" | "U" | "D";
  isDeleted?: boolean;
  isRemoved?: boolean;
}

interface MbOrg {
  id?: number;
  name: string;
  // 계약자 유형이 개인이거나 사업자 정보가 없는 계약자(소유주 단독 등)는 null 로 내려온다
  bizType: BizType | null;
  bizRegNo: string;
  corRegNo: string;
  ceoName: string;
  bizCondition: string;
  bizItem: string;
  taxType: TaxType;
  address: string;
  email: string;
  phoneNumber: string;
  regDate: string;
  createdDate: string;
  lastModifiedDate: string;
  lastModifiedBy: string;
  classifications: string[];
  partnerId: string;
  createdBy: string;
  bizLocationType: BizLocationType;
}

interface MbOrgMedia {
  id: number;
  fileStorageType: string;
  key: string;
  filename: string;
  contentType: string;
  fileSize: number;
  type: MediaType;
  name: string;
}

interface MbOrgDetail {
  mediaList?: MbOrgMedia[];
  organization: MbOrg;
}

// 관리자메모 쿼리파람
export interface OrgAdminMemoListParams {
  page?: number;
  size?: number;
  sort?: Sort;
}

export interface OrgAdminNoteType {
  id?: number;
  content?: string;
  createdDate?: string;
  createdBy?: string;
  lastModifiedDate?: string;
  lastModifiedBy?: string;
}

// 사업자 관리자메모 목록 타입
export interface OrgAdminMemoModel {
  adminNote: OrgAdminNoteType;
  orgId: number;
}

export interface OrgAdminMemoListResponse {
  content: Array<OrgAdminMemoModel>;
}

export { BizType, MediaType, TaxType };
export type { MbOrg, MbOrgDetail, MbOrgMedia, RequestInfo, SaveMediaDto, SaveOrgDto, SendBody };
